export class MockDomSanitizer {
  sanitize = jasmine.createSpy('sanitize');
  bypassSecurityTrustUrl = jasmine.createSpy('bypassSecurityTrustUrl');
  bypassSecurityTrustResourceUrl = jasmine.createSpy('bypassSecurityTrustResourceUrl');
}
